import React, { useEffect, useState } from 'react';
import { FaOptionIcon } from '@europrocurement/l2d-icons';
import { IconButton, Menu } from '@mui/material';
import { FactureOpenSearch } from '@europrocurement/l2d-domain';
import MenuDownloadInvoice from '@europrocurement/l2d-modules/src/modules/Factures/components/list/menuActionItems/MenuDownloadInvoice';
import MenuAccessToDossierCollection from '@europrocurement/l2d-modules/modules/Factures/components/list/menuActionItems/MenuAccessToDossierCollection';
import MenuPreviewInvoice from '@europrocurement/l2d-modules/modules/Factures/components/list/menuActionItems/MenuPreviewInvoice';
import { ordersBasePath } from '../../../../Orders/constants';

export type ActionMenuListeFactureProps = {
    facture: FactureOpenSearch;
};

const ActionMenuListeFacture: React.FunctionComponent<ActionMenuListeFactureProps> = function ({
    facture,
}) {
    const [dossierCollectionId, setDossierCollectionId] = useState<number | undefined>();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    useEffect(() => {
        // extract first dossierId or display an other subMenu ?
        if (facture.dossiers && facture.dossiers.length > 0) {
            if (facture.dossiers[0].collectionId) {
                setDossierCollectionId(facture.dossiers[0].dossierId);
            }
        }
    }, [facture.dossiers]);

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
            onKeyDown={() => {}}
            role="button"
            tabIndex={0}
        >
            <IconButton
                aria-label="more"
                id="long-button"
                aria-controls={open ? 'long-menu' : undefined}
                aria-expanded={open ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleClick}
            >
                <FaOptionIcon
                    icon={['fasl', 'ellipsis-vertical']}
                    sx={{ fontSize: '1rem' }}
                />
            </IconButton>
            <Menu
                id="long-menu"
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                <MenuDownloadInvoice facture={facture} />

                {dossierCollectionId && (
                    <MenuAccessToDossierCollection
                        dossierCollectionId={dossierCollectionId}
                        dossierCollectionBasePath={ordersBasePath}
                    />
                )}
                <MenuPreviewInvoice facture={facture} />
            </Menu>
        </div>
    );
};

export default ActionMenuListeFacture;
